import moment from 'moment';
import { Crop } from 'react-image-crop';

export interface MapCropperPropTypes {
  active: boolean;
  setActive: React.Dispatch<React.SetStateAction<boolean>>;
  imageUrl: string;
}

export const defaultCropParameters: Crop = {
  x: 490,
  y: 170,
  width: 450,
  height: 300,
  unit: 'px',
};

export const getCroppedImage = (ref: React.RefObject<HTMLImageElement>, croppedMapImage: Crop) => {
  const canvas = document.createElement('canvas');
  if (ref.current && croppedMapImage) {
    const scaleX = ref.current.naturalWidth / ref.current.width;
    const scaleY = ref.current.naturalHeight / ref.current.height;
    canvas.width = croppedMapImage.width;
    canvas.height = croppedMapImage.height;
    const ctx = canvas.getContext('2d');
    if (ctx) {
      ctx.drawImage(
        ref.current,
        croppedMapImage.x * scaleX,
        croppedMapImage.y * scaleY,
        croppedMapImage.width * scaleX,
        croppedMapImage.height * scaleY,
        0,
        0,
        croppedMapImage.width,
        croppedMapImage.height,
      );
    }
    const base64Image = canvas.toDataURL('image/jpeg', 1);

    const link = document.createElement('a');
    link.href = base64Image;
    document.body.appendChild(link);
    link.style.display = 'none';
    link.target = '_blank';
    link.setAttribute('download', `hymots-c/${moment().format('DD/MM/YYYY hh:mm')}`);
    link.click();
    document.body.removeChild(link);
  }
};
